import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      lang: 'Français',
      cta1a: 'Reduce Your',
      cta1b: 'Risk Quiz',
      cta2: 'How much do you know about the risks of substance use?',
      takeTheQuiz: 'Take the Quiz',
      instructions: 'Instructions',
      instruction1: 'Answer the questions and test your knowledge!',
      instruction2: 'Spin to win for prizes.',
      instruction3: 'Good luck!',
      next: 'Next',
      firstName: 'First Name',
      lastName: 'Last Name',
      agreement1: 'I agree to the',
      agreement2: 'Terms & Conditions.',
      termsAndConditions: 'Terms & Conditions',
      termsAndConditions1:
        'By providing your name, you consent to Health Canada using this information to email you, should you be the winner of the prize draw for a <span className="font-bold">$5 coffee gift card (or equivalent prize)</span>.',
      termsAndConditions2:
        'This information will not be used for sales or marketing solicitation or shared with any third-party entity.',
      termsAndConditions3: 'We will not retain any personal data once the game is over.',
      termsAndConditions4:
        'No purchase necessary. Open to age of majority residents of Canada. Contest opens September 20th at 9 AM and closes November 30th at 5 PM. 50 PRIZES are available each day consisting of a $5 coffee gift card. Limit 1 entry per person. Odds depend on number of eligible entries. Full rules and entry details available upon request.',
      close: 'Close',
      submit: 'Submit',
      results1: 'Thank you for taking the Quiz!',
      results2: 'You got',
      results3: 'out of 10 questions correct.',
      nowSpinToWin: 'NOW SPIN TO WIN!',
      spinAndWin: 'Spin and Win!',
      spin: 'Spin',
      thankYou: 'Thank You',
      thankYouForStoppingBy: 'Thank you for stopping by! Please come back tomorrow.',
    },
  },
  fr: {
    translation: {
      lang: 'English',
      cta1a: 'Questionnaire : ',
      cta1b: 'réduis ton risque',
      cta2: 'Que sais-tu des risques liés à la consommation de substances?',
      takeTheQuiz: 'Commence ici',
      instructions: 'Instructions',
      instruction1: 'Répond aux questions et teste tes connaissances!',
      instruction2: 'Joue pour gagner un prix.',
      instruction3: 'Bonne chance!',
      next: 'Suivant',
      firstName: 'Prénom',
      lastName: 'Nom',
      agreement1: "J'accepte les",
      agreement2: 'termes et conditions',
      termsAndConditions: 'Modalités et conditions',
      termsAndConditions1:
        'En fournissant votre nom, vous consentez à ce que Santé Canada utilise ces renseignements pour communiquer avec vous par courriel si vous êtes la personne gagnante du tirage d’un prix consistant en une carte-cadeau de café de 5 $ (ou un prix équivalent).',
      termsAndConditions2:
        'Ces renseignements ne seront pas utilisés à des fins de sollicitation commerciale ou de marketing et ne seront communiqués à aucun tiers.',
      termsAndConditions3: 'Nous ne conserverons aucun renseignement personnel une fois le jeu terminé.',
      termsAndConditions4:
        'Aucun achat requis. Ouvert aux résidents du Canada ayant atteint l’âge de la majorité dans leur province ou territoire de résidence. Le concours débute le 20 septembre à 9 h et se termine le 30 novembre à 17 h. 50 PRIX sont offerts chaque jour, chacun consistant en une carte-cadeau de café de 5 $. Limite d’une participation par personne. Les chances de gagner dépendent du nombre de participations admissibles reçues. Le règlement complet et les détails de participation sont disponibles sur demande.',
      close: 'Fermer',
      submit: 'Soumettre',
      results1: 'Merci d’avoir participé au quiz!',
      results2: 'Tu as répondu correctement à',
      results3: 'sur 10 questions.',
      nowSpinToWin: 'MAINTENANT JOUE POUR GAGNER!',
      spinAndWin: 'Maintenant joue pour gagner!',
      spin: 'Rotation',
      thankYou: 'Merci',
      thankYouForStoppingBy: 'Thank you for stopping by! Please come back tomorrow.',
    },
  },
};

i18n
  .use(initReactI18next) //passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', //language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    //you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    //if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, //react already safes from xss
    },
  });

export default i18n;
